import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';

import { AppDatePickerInputMaxType } from 'src/app/core/types/app-date-picker-input-max-type.type';
import { AppDatePickerInputMinType } from 'src/app/core/types/app-date-picker-input-min-type.type';

@Component({
    selector: 'app-periodic-date-picker',
    templateUrl: './periodic-date-picker.component.html',
    standalone: false
})
export class PeriodicDatePickerComponent implements OnInit {
  //#region properties
  #dialogService = inject(DialogService);

  @Input() config: PeriodicDateConfig;

  @Output('startDate') output_startDateValue = new EventEmitter<any>();
  @Output('endDate') output_endDateValue = new EventEmitter<any>();

  @Input() startDate;
  @Input() endDate;

  isShowError: boolean = false;

  //#endregion

  constructor() {}

  ngOnInit() {
    this.initValues();
  }

  ngOnChanges(): void {
    this.initValues();
  }

  initValues() {
    if (this.config.startDateValue) this.startDate = this.config.startDateValue;
    if (this.config.endDateValue) this.endDate = this.config.endDateValue;
  }

  showErrorDialog(event: any) {
    this.#dialogService.openDialog({
      title: 'common.error',
      message: event?.errorMessage,
      status: DialogStatus.error,
    });
  }

  emitStartDate() {
    this.output_startDateValue.emit(this.startDate);
  }

  emitEndDate() {
    this.output_endDateValue.emit(this.endDate);
  }
}

export interface PeriodicDateConfig {
  minStartDateType?: AppDatePickerInputMinType;
  maxStartDateType?: AppDatePickerInputMaxType;

  minEndDateType?: AppDatePickerInputMinType;
  maxEndDateType?: AppDatePickerInputMaxType;
  isEditMode?: boolean;
  startDateLabel?: string;
  endDateLabel?: string;
  isShowStartDate?: boolean;
  isShowEndDate?: boolean;
  startDateFormControl?: FormControl;
  endDateFormControl?: FormControl;
  responsiveClassName?: string;
  startDateValue?: any;
  endDateValue?: any;
  isConvertToIsoString?: boolean;
}
